export default function TemplateSelector({ onSelect }) {
  return (
    <div className="template-selector">
      <h2>Choose Input Method</h2>
      <div className="selector-grid">
        <div
          className="selector-card"
          onClick={() => onSelect('manual')}
        >
          <div className="card-icon">✏️</div>
          <h3>Manual Input</h3>
          <p>Enter product details one by one</p>
          <p className="sub-text">For creating individual designs</p>
        </div>

        <div
          className="selector-card"
          onClick={() => onSelect('bulk')}
        >
          <div className="card-icon">📤</div>
          <h3>Bulk Upload</h3>
          <p>Upload CSV file with multiple products</p>
          <p className="sub-text">For creating designs at scale</p>
        </div>
      </div>
    </div>
  )
}
